import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import FromApp from '../../../components/ResourceSelector/FromApp';
import Utils from '../../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos,
		driveList,
	} = state;
	const { breadcrumbs } = driveList;

	return {
		driveList,
		privateDirId: Utils.getPrivateDirId(driveList, galleryInfos.config),
		sharedDirId: Utils.getSharedDirId(driveList, galleryInfos),
		applicationId: galleryInfos.config.applicationGallery,
		currentDriveId: breadcrumbs.length === 0
			? null
			: breadcrumbs[breadcrumbs.length - 1].id,
	};
};

export default connect(mapStateToProps)(FromApp);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ResourceSelector/FromApp/index.tsx